<template>
  <div class="homicides-container">
    <span class="homicides-label">
      Cumulative homicide trends
    </span>
    <chartist
      ratio="ct-major-second"
      type="Line"
      :data="trendData"
      :options="options"
      :responsive-options="responsiveOptions"
    />
    <ul class="legend-list">
      <li
        v-for="(label, i) in labels"
        :key="label.name"
        :class="legendClass(i)"
      >{{ label.name }}<span class="mobile-hide">: {{ label.count }} victims</span></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "TrendChart",
  data() {
    return {
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ]
    };
  },
  props: {
    allVictims: Array,
    currentYear: String,
    trendLength: {
      type: Number,
      default: 6
    }
  },
  methods: {
    legendClass(i) {
      let className = `legend-${i}`;
      return {
        [className]: true
      };
    },
    cummulativeDataFor(year) {
      let yearStr = String(year);
      let days = [];

      // Count how many victims per day of the year
      // JavaScript allows sparse arrays!
      this.allVictims.forEach(victim => {
        if (victim.year === yearStr) {
          let day = victim.dateObject.ordinal;
          if (!days[day]) {
            days[day] = 0;
          }
          days[day]++;
        }
      });

      // Make it cummulative
      let total = 0;
      let data = [];
      days.forEach((val, idx) => {
        total += val;
        // Change to an x/y object
        data.push({ x: idx, y: total });
      });

      return data;
    }
  },
  computed: {
    responsiveOptions() {
      // Only month initial letter J F M, etc on mobile
      return [
        [
          "screen and (max-width: 780px)",
          {
            axisX: {
              labelInterpolationFnc: (value, i) => {
                return this.months[i][0];
              }
            }
          }
        ]
      ];
    },
    options() {
      return {
        lineSmooth: this.$chartist.Interpolation.monotoneCubic({
          fillHoles: true
        }),
        showPoint: false,
        axisX: {
          type: this.$chartist.FixedScaleAxis,
          labelInterpolationFnc: (value, i) => {
            return this.months[i];
          },
          showGrid: true,
          // Ticks for months on (non-leap year) days
          ticks: [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334]
        },
        axisY: {
          onlyInteger: true,
          position: "end"
        },
        series: {
          [this.currentYear]: {
            showArea: true
          }
        }
      };
    },
    yearsArr() {
      let years = [];
      for (let i = 0; i < this.trendLength; i++) {
        years.push(this.currentYear - i);
      }
      return years;
    },
    trendData() {
      let series = this.yearsArr
        .map((year, i) => ({
          name: String(year),
          data: this.cummulativeDataFor(year),
          // Setting classnames manually, so that the current year can be on top
          className: "ct-series-" + this.$chartist.alphaNumerate(i)
        }))
        .reverse();

      return { labels: this.months, series };
    },
    labels() {
      return this.trendData.series
        .map(({ name, data }) => ({
          name,
          count: data.length ? data[data.length - 1].y : 0
        }))
        .reverse();
    }
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 780px) {
  .mobile-hide {
    display: none;
  }
}
</style>
